import React from 'react';
import { FaStar } from 'react-icons/fa';

const reviews = [
  {
    name: 'Muskaan Prajapati',
    institution: 'Shyama Prasad Mukherji College for Women, Delhi University, Economics Honours',
    stars: 5,
    comment: 'This program of Traineeship and Internship provided by the Internselite is much better. It was a good experience to learn and work in Internselite..'
  },
  {
    name: 'Anshuman Maitra',
    institution: 'Govt. College of Engineering and Leather Technology, CSE',
    stars: 5,
    comment: 'Coding is something that can\'t be done exclusively. We need community, team, mentors... In this internship, I have gained such mentors as my teacher, Ayan sir to support freshers like me at any time to overcome our boundaries.... This is the embryonic stage of my journey as a AI/ML enthusiast which I have got to know from this internship.... Thank you InternsElite for giving me this opportunity..'
  },
  {
    name: 'Khushi Prajapati',
    institution: 'Shyama Prasad Mukherji College for Women, Delhi University',
    stars: 4,
    comment: 'I am very much satisfied with the overall program from the training sessions, learnt a lot and it is able to build a strong base in my concept. Thank you for such a wonderful traineeship program.'
  },
  {
    name: 'Nalamekala Sindhu',
    institution: 'Annamacharya Institute of Technology and Sciences, Tirupati, CSE',
    stars: 5,
    comment: 'Internsellite\'s team demonstrated exceptional dedication, delivering high-quality results with professionalism and adaptability. Their impact on our project\'s success is commendable, making the collaboration a valuable experience.'
  },
  {
    name: 'Tohuto Sema',
    institution: 'Computer Science and Engineering - IIT Kharagpur',
    stars: 4,
    comment: 'Hello, I\'m Tohuto Sema. Internselite\'s Python course enlightened me on building models using libraries like scikit-learn and numpy. Despite wanting more hands-on tasks and finding the duration a bit lengthy, I gained valuable insights, and I\'m grateful for the learning experience.'
  },
  {
    name: 'Aditya Mahadev Falle',
    institution: 'TKIET Warananagar, Mechanical Engineering',
    stars: 4,
    comment: 'Grateful for the invaluable internship experience with Internselite. The supportive team and gained insights in Python have significantly contributed to my personal and professional growth. Excited about potential future collaborations with Internselite'
  }
];

function PY_Review_Program_Page() {
  return (
    <div>
      <div>
        <div className='container'>
          <div className='row d-sm-block d-md-none'>
            <div className='col-md-1'></div>
            <div className='col-md-10'>
              <div className='text-center review_component_text'>
                <h2 className='display-5 pb-2'>Testimonial</h2>
                <p className='fs-6'>Listen to the people who have made it! Explore the testimonies of former students who attested to the life-altering effects of their educational experiences.</p>
              </div>
            </div>
            <div className='col-md-1'></div>
          </div>
          <div className='row'>
            <div className='col-md-4 pt-5'>
              <div className='Program_review_comp'>
                <div className='mt-5 px-5 review_component_text'>
                  <h2 className='pt-5 display-6'>Hear What Our Students Say</h2>
                  <p className='pt-4 fs-5'>25K+ Students have already learned with InternsElite</p>
                </div>
              </div>
            </div>
            <div className='col-md-8'>
              <div className='row'>
                {reviews.map((review, index) => (
                  <div key={index} className={`col-md-${index % 2 === 0 ? '5' : '7'} card`}>
                    <div className='card-body'>
                      <h5 className='font-weight-bold Review_not_copy'>{review.name}</h5>
                      <h6 className='font-weight-bold my-2 Review_not_copy'>{review.institution}</h6>
                      <ul className='list-unstyled d-flex justify-content-start Review_not_copy'>
                        {Array.from({ length: 5 }).map((_, starIndex) => (
                          <li key={starIndex}>
                            <FaStar color={starIndex < review.stars ? 'gold' : 'grey'} />
                          </li>
                        ))}
                      </ul>
                      <p className='Review_not_copy'>
                        <i className='fas fa-quote-left pe-2'></i>{review.comment}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PY_Review_Program_Page;
